import { render, staticRenderFns } from "./Towns.vue?vue&type=template&id=4bad7344&scoped=true"
import script from "./Towns.vue?vue&type=script&lang=js"
export * from "./Towns.vue?vue&type=script&lang=js"
import style0 from "./Towns.vue?vue&type=style&index=0&id=4bad7344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad7344",
  null
  
)

export default component.exports